import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_COPY: GlameraIconDefinition = {
  name: 'copy',
  viewBox: '0 0 24 24',
  svg: `
    <rect
      class="glm-copy-front"
      width="14"
      height="14"
      x="8"
      y="8"
      rx="2"
      ry="2">
    </rect>
    <path
      class="glm-copy-back"
      d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2">
    </path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-copy-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './copy.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CopyIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_COPY;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
